const ExperienceData = [
  {
    id: 1,
    jobtitle: "Head of IQ Department",
    companyname: "Vibinyo solution",
    worktype: "Full-time",
    duration: "July 2021 - March 2022",
    location: "chennai",
    responsibility: [
      `Guided a team of 70 members  and over 5 team leaders.`,
      `Collecting the data from our staff in each hour`,
      `Handle the customer`,
      `In 6 months  company was improved by 7% .`,
      `Resolved all client complaints`,
      `Individual performance review and weekly meetings with the team.`,
    ],
  },
 
];

const EducationData = [
  {
    name: "JPR Maamallan Engg college",
    status: "Mechanical Engineering",
    year: "2021",
  },
  {
    name: "Guvi Geek network Pvt.Ltd",
    status: "MERN stack developer",
    year: "March-2022 -August-2022",
  },
  
];

const CertificationData = [
  {
    name: "MERN stack developer",
    source: "Guvi Geek network Pvt.Ltd",
    date: "Issued Aug 2022 · No Expiration Date",
    creditUrl:
      "https://www.guvi.in/courses",
  },
 
];

export { ExperienceData, EducationData, CertificationData };
